module.exports = require("shallow-equal");